import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../common/ButtonComp';
import './ProfileComp.css';
import UserActions from '../actions/user.actions';
import Input from 'react-toolbox/lib/input';
import { bindActionCreators } from 'redux';
import { Row, Col } from 'react-flexbox-grid';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import MdCheckCircle from 'react-icons/lib/md/check-circle';
import MdUncheckCircle from 'react-icons/lib/md/radio-button-unchecked';

import { getTranslate } from 'react-localize-redux';

class SettingsComp extends Component {
  state = {
    email: null
  };

  constructor(props) {
    super(props);
    const {
      me: {
        user: { email, contactEmail }
      }
    } = this.props;

    this.state = {
      email: contactEmail || email
    };
  }

  saveSettings = () => {
    const {
      userActions: { saveSettings }
    } = this.props;

    saveSettings(this.state);
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  deleteUser = () => {
    const {
      me: {
        user: { id }
      }
    } = this.props;

    this.props.userActions.deleteUser({ uid: id });
  };

  toggleUser = () => {
    const {
      me: {
        user: { id, email, disabled }
      }
    } = this.props;

    if (disabled !== true) {
      const isConfirmed = window.confirm(`Confirm that you want to disable the user ${email} !`);
      if (!isConfirmed) return false;
      this.props.userActions.disableUser({ uid: id });
    } else {
      this.props.userActions.enableUser({ uid: id });
    }
  };

  render() {
    const {
      translate,
      me: {
        saveSettings,
        user: { isAdmin, disabled }
      }
    } = this.props;

    const adminPanel = isAdmin && (
      <div>
        <h2>ADMIN</h2>
        <Button big primary danger onClick={this.deleteUser.bind(this)}>
          DELETE USER
        </Button>
      </div>
    );

    const { email } = this.state;

    return (
      <div className="profile">
        <h1 className="profile-header">{translate('profile.user_settings')}</h1>
        <div className="content">
          <Input
            type="text"
            label={translate('profile.contact_email')}
            value={email}
            onChange={this.handleChange.bind(this, 'email')}
          />
          <Button big primary onClick={this.saveSettings.bind(this)} loading={saveSettings}>
            {translate('app.save')}
          </Button>

          {adminPanel}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    translate: getTranslate(state.locale),
    me: state.me
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(UserActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsComp);



// WEBPACK FOOTER //
// ./src/profile/ProfileComp.js